export const getIndexesGosrComments = (state) => state.indexesGosr.comments;
